<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          appInfo = { plansPricesMonth: {}, ...data?.metaData }
          this.isLoading = false
        }
      "
      contentId="appInfo"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Frais & Paiements</div>
      <div>
        <button class="buttonComponent" @click="saveData" v-if="haveUpdate">
          Enrégister
        </button>
      </div>
    </div>
    <div class="py-2"></div>
    <!-- {{ appInfo }} -->

    <div class="flex flex-col gap-6">
      <div class="bg-white rounded-2xl p-4 flex flex-col">
        <div class="font-bold">Plans</div>
        <div class="py-2"></div>
        <div>
          <InputComponent
            type="number"
            suffix="FCFA"
            v-model="updatedData.plansPricesMonth.basic"
            label="Accès Basic"
          />
        </div>
        <div class="py-2"></div>
        <div>
          <InputComponent
            type="number"
            suffix="FCFA"
            v-model="updatedData.plansPricesMonth.essenciel"
            label="Accès Essentiel"
          />
        </div>
        <div class="py-2"></div>
        <div>
          <InputComponent
            type="number"
            suffix="FCFA"
            v-model="updatedData.plansPricesMonth.ekilite"
            label="Accès Eki Lite"
          />
        </div>
        <div class="py-2"></div>
        <div>
          <InputComponent
            type="number"
            suffix="FCFA"
            v-model="updatedData.plansPricesMonth.ekipro"
            label="Accès Eki Pro"
          />
        </div>
      </div>

      <div class="bg-white rounded-2xl p-4 flex flex-col">
        <div class="font-bold">Frais Basic</div>
        <div class="py-2"></div>
        <SettingFeesSection userId="marketplace" />
      </div>

      <div class="bg-white rounded-2xl p-4 flex flex-col">
        <div class="font-bold">Frais Pro</div>
        <div class="py-2"></div>
        <SettingFeesSection userId="marketplacePro" />
      </div>

      <div class="bg-white rounded-2xl p-4 flex flex-col">
        <div class="font-bold">Paiements par carte</div>
        <div class="py-2"></div>
        <!-- <InputComponent
          v-model="updatedData.merchandPaymentFeeMobileMoney"
          type="number"
          suffix="%"
          label="Frais après paiement client: Mobile Money"
        />
        <InputComponent
          v-model="updatedData.merchandPaymentFeeCardQos"
          type="number"
          suffix="%"
          label="Frais après paiement client: Carte Qos "
        />
        <InputComponent
          v-model="updatedData.merchandPaymentFeeCardCinetpay"
          type="number"
          suffix="%"
          label="Frais après paiement client: Carte CinetPay "
        />
        <InputComponent
          v-model="updatedData.merchandPaymentFeeCardStripe"
          type="number"
          suffix="%"
          label="Frais après paiement client: Carte Stripe "
        /> -->
        <div class="relative z-[1] flex items-center flex-col">
          <InputComponent
            v-model="updatedData.cardPaymentAvailablilityDelayUnit"
            type="select"
            :options="['min', 'hour', 'day']"
            class="!border-transparent !bg-transparent !w-[10rem] !absolute right-0 z-[2] [&_indput]:opacity-0"
          />
          <InputComponent
            v-model="updatedData.cardPaymentAvailablilityDelay"
            type="number"
            label="Durée de disponibilité des fonds"
          />
        </div>
      </div>
      <!-- 
      <div class="bg-white rounded-2xl p-4 flex flex-col">
        <div class="font-bold">Ekidiscount Pro</div>
        <div class="py-2"></div>
        <InputComponent
          v-model="updatedData.ekidiscountProFee"
          type="number"
          suffix="FCFA"
          label="Frais d'abonnement"
        />
      </div> -->

      <div class="bg-white rounded-2xl p-4 flex flex-col">
        <div class="font-bold">Promotion de produits (A la une)</div>
        <div class="py-2"></div>
        <InputComponent
          v-model="updatedData.topProductPromotionCostPerDay"
          type="number"
          suffix="FCFA"
          label="Coût par jour"
        />
        <InputComponent
          v-model="updatedData.topProductPromotionMinDuration"
          type="number"
          suffix="Jour(s)"
          label="Durée minimale de promotion"
        />
      </div>
      <div class="py-24"></div>
    </div>

    <EventListener
      :events="['app_info_saved', 'failed_to_save_app_info']"
      @app_info_saved="onInfoSaved"
      @failed_to_save_app_info="onFailedToSave"
    />
  </div>
</template>

<script>
import SettingFeesSection from '@/components/settings/SettingFeesSection.vue'
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import InputComponent from '@/components/utils/InputComponent.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    InputComponent,
    EventListener,
    SettingFeesSection,
  },
  data() {
    return {
      appInfo: {},
      updatedData: { plansPricesMonth: {} },
      isLoading: true,
      haveUpdate: false,
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    saveData() {
      this.$Events.dispatchEvent('app_info_update_available', this.updatedData)
    },
    onInfoSaved() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Infos enrégistrées correctement',
        body: 'Les informations ont été enrégistrées avec succès',
      })
      this.updatedData = JSON.parse(JSON.stringify(this.appInfo))
      this.haveUpdate = false
      setTimeout(() => {
        this.haveUpdate = false
      })
      setTimeout(() => {
        this.haveUpdate = false
      }, 100)
    },
    onFailedToSave() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echec de sauvegarde',
        body: 'Désolé, les données ne sont pas enrégistrée, veuillez réessayer',
      })
    },
    availabilityDisplay(data) {
      return data
    },
  },
  watch: {
    appInfo(newVal) {
      if (!this.haveUpdate) {
        this.updatedData = JSON.parse(JSON.stringify(newVal))
        this.haveUpdate = false
        setTimeout(() => {
          this.haveUpdate = false
        })
        setTimeout(() => {
          this.haveUpdate = false
        }, 100)
      }
    },
    updatedData: {
      deep: true,
      handler() {
        this.haveUpdate = true
      },
    },
  },
  computed: {
    // haveUpdate() {
    //   return JSON.stringify(this.appInfo) !== JSON.stringify(this.updatedData)
    // },
  },
}
</script>
